import { useWallet } from "@manahippo/aptos-wallet-adapter";
import { TokenId } from "@martiandao/aptos-web3-bip44.js";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

import Button from "../../components/Common/Button";
import { getNowSeconds } from "../../libs/aptos_sdk";
import {
  getFoilNFTs,
  getLockedBalance,
  getVestValue,
} from "../../libs/vesting_escrow";
import { getTokenId, getDateFormat } from "../../utils/common";
// export interface LockingBalance {
//   amount: number;
//   end: number;
// }
export interface TokenInfo {
  token_id: number;
  locking_amount: number;
  locking_end: number;
  vest_value: string;
}
export default function Vest() {
  const navigate = useNavigate();
  const [nftsInfo, setNftsInfo] = useState<TokenInfo[]>([]);

  const { account } = useWallet();
  const [now, setNow] = useState<number>(new Date().getTime() / 1000);

  const getExpireString = (end: number): string => {
    if (end < now) {
      const duration = (now - end) / 86400;
      if (duration < 1) {
        return `Expires 1 day ago`;
      } else {
        return `Expires ${Math.ceil(duration)} days ago`;
      }
    } else {
      const duration = (end - now) / 86400;
      if (duration < 1) {
        return `Expires in 1 day`;
      } else {
        return `Expires in ${Math.ceil(duration)} days`;
      }
    }
  };

  useEffect(() => {
    getNowSeconds().then((seconds) => {
      setNow(seconds);
    });
  }, []);
  useEffect(() => {
    if (account) {
      getFoilNFTs(account.address as string).then(async (res: TokenId[]) => {
        const res_nfts_info: TokenInfo[] = [];
        for (let i = 0; i < res.length; i++) {
          const token_id: TokenId = res[i];
          const token_id_num = getTokenId(token_id.token_data_id.name);
          const locked_balance = await getLockedBalance(token_id_num);
          const locking_amount = locked_balance.amount / 1000000000;
          const locking_end = locked_balance.end;
          const vest_value = await getVestValue(token_id_num);
          res_nfts_info.push({
            token_id: token_id_num,
            locking_amount,
            locking_end,
            vest_value: (vest_value / 1000000000).toFixed(2),
          });
        }
        setNftsInfo(res_nfts_info);
      });
    }
  }, [account]);

  return (
    <div className="flex min-h-screen py-16">
      <div className="flex flex-col gap-8 p-10 w-full">
        <div className="flex w-full gap-4">
          <Button
            className="text-base px-10 font-normal"
            onClick={() => {
              navigate("/vest/create");
            }}
          >
            Create Lock
          </Button>
        </div>

        <div className="bg-white rounded-lg bg-opacity-10 w-full">
          <div className="max-w-full overflow-x-scroll">
            <div className="w-full max-xl:w-[1000px]">
              <table className="w-full">
                <thead className="bg-white bg-opacity-10 text-white w-full">
                  <tr>
                    <th className="py-3">Pair</th>
                    <th>Vest Amount</th>
                    <th>Vest Value</th>
                    <th>Vest Expires</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {nftsInfo.map((nft: TokenInfo, index: number) => {
                    return (
                      <tr key={`token_key_${index}`}>
                        <td>
                          <div className="flex justify-center items-center pl-2 pt-1 flex-col">
                            <div className="flex gap-2">
                              <p className="font-semibold text-white">
                                {nft.token_id}
                              </p>
                            </div>
                            <div className="flex gap-2">
                              <p className="text-white text-opacity-50">
                                NFT ID
                              </p>
                            </div>
                          </div>
                        </td>
                        <td>
                          <div className="flex justify-center items-center pl-2 pt-1 flex-col">
                            <div className="flex gap-2">
                              <p className="font-semibold text-white">
                                {nft.locking_amount}
                              </p>
                            </div>
                            <div className="flex gap-2">
                              <p className="text-white text-opacity-50">
                                FoilCoin
                              </p>
                            </div>
                          </div>
                        </td>
                        <td>
                          <div className="flex justify-center items-center pl-2 pt-1 flex-col">
                            <div className="flex gap-2">
                              <p className="font-semibold text-white">
                                {nft.vest_value}
                              </p>
                            </div>
                            <div className="flex gap-2">
                              <p className="text-white text-opacity-50">
                                veNFT
                              </p>
                            </div>
                          </div>
                        </td>
                        <td>
                          <div className="flex justify-center items-center pl-2 pt-1 flex-col">
                            <div className="flex gap-2">
                              <p className="font-semibold text-white">
                                {getDateFormat(
                                  new Date(nft.locking_end * 1000)
                                )}
                              </p>
                            </div>
                            <div className="flex gap-2">
                              <p className="text-white text-opacity-50">
                                {getExpireString(nft.locking_end)}
                              </p>
                            </div>
                          </div>
                        </td>
                        <td className="py-2">
                          <div className="flex justify-center items-center pl-2 pt-1 flex-col">
                            <Button
                              variant="gradient"
                              className="w-32"
                              onClick={() => {
                                navigate(`/vest/${nft.token_id}`);
                              }}
                            >
                              Manage
                            </Button>
                          </div>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
